"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.library.empty': 'Sin publicaciones',
    'socialMediaPlan.library.emptyDesc': 'Crea tu primera publicación.',
    'socialMediaPlan.library.contains_errors': 'Esta publicación contiene errores de publicación',
};
